<div class="upload-content">
  <div>
    <input
      type="file"
      hidden
      #fileDropRef
      (change)="handleFileSelect($event)"
      multiple
    />

    <div *ngIf="!dragged; else notifyLoading" class="drop-section">
      <!-- <div class="uploaded-files-grid" *ngIf="uploadedFiles.length > 0"> -->
      <div class="file-item" *ngFor="let file of uploadedFiles; let i = index">
        <img
          *ngIf="file.fileType.startsWith('image/')"
          [src]="'data:' + file.fileType + ';base64,' + file.fileData"
          [alt]="file.fileName"
          class="uploaded-image"
        />

        <img
          *ngIf="file.fileType.includes('pdf')"
          src="../../../../assets/images/pdf-logo.png"
          class="cv-document"
          [alt]="file.fileName"
        />

        <!-- Exibir ícone genérico para outros tipos de arquivos -->
        <img
          *ngIf="
            !file.fileType.startsWith('image/') &&
            !file.fileType.includes('pdf')
          "
          src="assets/images/file-icon.png"
          class="cv-document"
          [alt]="file.fileName"
        />

        <div class="btn-remover">
          <button
            *ngIf="preview"
            [disabled]="!file.fileType.startsWith('image/')"
            class="btn btn-danger btn-sm"
            (click)="openPreviewModal(file)"
          >
            <span class="mdi mdi-eye-outline"></span>
          </button>

          <button
            class="btn btn-danger btn-sm"
            (click)="removeUploadFile(file, i)"
          >
            <span class="mdi mdi-delete-outline"></span>
          </button>
        </div>
      </div>
      <!-- </div> -->

      <button
        type="button"
        class="btn p-0 custom-button"
        (click)="fileDropRef.click()"
        [hidden]="hideAddFileButton"
      >
        <i class="mdi mdi-plus"></i>
        <span>Adicionar arquivo</span>
      </button>

      <span class="text-danger d-block" *ngIf="showInvalidFileFormat"
        >Formato selecionado inválido.</span
      >
      <span class="text-danger d-block" *ngIf="showFileSizeExceededError"
        >O arquivo selecionado é muito grande. tamanho máximo aceito é
        {{ fileSizeLimit | kbToMb }} e o tamanho do arquivo é
        {{ lastFileSelected.size | kbToMb }}</span
      >
      <span class="text-danger d-block" *ngIf="showTotalFileSizeExceededError"
        >Os arquivos selecionados ultrapassam o limite de
        {{ totalFileSizeLimit | kbToMb }}.</span
      >
      <span class="text-danger d-block" *ngIf="showExceededFileLimit"
        >O número máximo de {{ maxFiles }} arquivos foi excedido.</span
      >
      <span
        class="text-danger d-block"
        *ngIf="dirtyLabel && dirtyLabel !== undefined"
        >{{ dirtyLabel }}</span
      >
    </div>

    <ng-template #notifyLoading>
      <p #notifyLoading>processando imagem...</p>
    </ng-template>
    <!-- Modal para exibir a imagem -->
  </div>

  <app-new-modal
    [modalOpen]="preview && !!previewFile"
    (closeModalEvent)="closePreviewModal()"
  >
    <div class="pdf-content">
      <img
        *ngIf="!!previewFile && previewFile.fileType.startsWith('image/')"
        [src]="
          'data:' + previewFile.fileType + ';base64,' + previewFile.fileData
        "
        [alt]="previewFile.fileName"
        class="uploaded-image"
      />
    </div>
  </app-new-modal>
</div>

<small *ngIf="allowedExtensions.length > 0" class="allowed-formats"
  >Formatos válidos: {{ allowedExtensionsView }}</small
>
